import { render, staticRenderFns } from "./common.vue?vue&type=template&id=e2de860e&scoped=true&"
import script from "./common.vue?vue&type=script&lang=ts&"
export * from "./common.vue?vue&type=script&lang=ts&"
import style0 from "./common.vue?vue&type=style&index=0&id=e2de860e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2de860e",
  null
  
)

export default component.exports